import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useUserOrganization } from '@/hooks/useUserOrganization'
import type { DashboardOrderEvent } from '../types/dashboard.types'

export function useOrderEvents(orderId: number | null) {
  const { data: membership } = useUserOrganization()
  const orgId = membership?.organization_id

  return useQuery({
    queryKey: ['dashboard-order-events', orgId, orderId],
    queryFn: async () => {
      const { data, error } = await supabase
        .schema('delivery')
        .rpc('dashboard_order_events', {
          p_org_id: orgId!,
          p_order_id: orderId!,
          p_event_type: undefined,
        })

      if (error) {
        console.error('Order events error:', error)
        throw error
      }

      return (data || []) as DashboardOrderEvent[]
    },
    enabled: !!orgId && !!orderId,
    staleTime: 30_000,
  })
}
